import { DeviceType } from 'services/pangolin/types';
import { HostDeviceType } from 'services/pangolin/protos/hosts_pb';

export const DeviceTypeList: DeviceType[] = [
  HostDeviceType.H_DESKTOP,
  HostDeviceType.H_MOBILE,
  HostDeviceType.H_GAMING,
  HostDeviceType.H_MEDIA,
  HostDeviceType.H_NETWORK,
  HostDeviceType.H_CAMERA,
  HostDeviceType.H_PRINTER,
  HostDeviceType.H_MISC,
];
